import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen, setViewingUserCategories } from '../../../../store/Actions';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FancyButton } from '../../../common/buttons';
import { FancyTextField } from '../../../common/inputs';
import EmojiPicker from 'emoji-picker-react';
import Menu from '@mui/material/Menu';
import { HexColorPicker } from "react-colorful";
import { categoryIsInEvents, deleteUserCategory, storeUserCategory } from '../../../../firebase/Firestore';

export function EditCategory(props) {
    const userCategories = useSelector(state=>state.viewingUserCategories);
    const dialogData = useSelector(state=>state.dialogData);
    const category = dialogData.category;
    const [name, setName] = useState(category.name);
    const [pinColor, setPinColor] = useState(category.pinColor);
    const [emojiAnchorEl, setEmojiAnchorEl] = useState(null);
    const [defaultEmoji, setDefaultEmoji] = useState(category.defaultEmoji);
    const dispatch = useDispatch();
    const cancelEdit = () => {
        // 'View Category' is no longer a dialog — the category detail page
        // lives in the URL now, so just close the modal.
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Category'){
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog, dialogData));
        }
    }

    const onSave = async ()=>{
        if(!name){
            alert('please enter a name');
            return;
        }
        const updatedCategory = await saveCategory();
        if(!dialogData.parentDialog || dialogData.parentDialog === 'View Category'){
            dispatch(setDialogOpen(''));
        } else {
            dispatch(setDialogOpen(dialogData.parentDialog));
        }
        void updatedCategory;
    }

    const saveCategory = async () => {
        const updatedCategory = await storeUserCategory(category.id, {...category, name, pinColor, defaultEmoji});
        dispatch(setViewingUserCategories({...userCategories, [updatedCategory.id]: updatedCategory}));
        return updatedCategory;
    }

    const deleteCategory = async() => {
        if(!window.confirm(`Are you sure you want to delete ${category.name}?`)) return;
        if(await categoryIsInEvents(category)){
            alert('This category exists in some of your events');
            return;
        }
        await deleteUserCategory(category.id);
        const updatedCategories = {...userCategories};
        delete updatedCategories[category.id];
        dispatch(setViewingUserCategories(updatedCategories));
        dispatch(setDialogOpen(dialogData.listDialog === null ? '' : (dialogData.listDialog || 'Categories')));
    }

    return (
        <>
            <DialogTitle>{dialogData.dialogTitle}</DialogTitle>
            <DialogContent style={{flex:1, width:'400px'}}>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <FancyTextField
                        label="Name"
                        fullWidth
                        style={{marginTop:'20px'}}
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                    />
                    <div>
                        <FancyButton
                            style={{marginTop:'20px', height:'auto', paddingTop:'6px', paddingBottom:'6px'}}
                            onClick={event => setEmojiAnchorEl(event.currentTarget)}
                        >
                            <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                                <div style={{fontSize:'9px'}}>Default Event Emoji</div>
                                <div style={{fontSize:'20px'}}>{defaultEmoji}</div>
                            </div>
                        </FancyButton>
                        <Menu
                            anchorEl={emojiAnchorEl}
                            open={Boolean(emojiAnchorEl)}
                            onClose={()=>setEmojiAnchorEl(null)}
                        >
                            <EmojiPicker 
                                previewConfig={{showPreview:false}} 
                                onEmojiClick={(emoji)=>{
                                    setDefaultEmoji(emoji.emoji); 
                                    setEmojiAnchorEl(null);
                                }}
                            />
                        </Menu>
                    </div>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'center', marginTop:'30px'}}>
                        <HexColorPicker color={pinColor} onChange={setPinColor} />
                        <div style={{height:'150px', width:'150px', borderRadius:'150px', backgroundColor:pinColor, marginLeft:'40px'}}/>
                    </div>
                </div>
            </DialogContent>
            <DialogActions style={{display:'flex', flexDirection:'row', justifyContent:'space-between', padding:'20px', paddingLeft:'24px', paddingRight:'24px'}}>
                <div>
                    {category.id &&
                        <FancyButton variant="danger" onClick={deleteCategory}>Delete</FancyButton>
                    }
                </div>
                <div style={{display:'flex', gap:'10px'}}>
                    <FancyButton onClick={cancelEdit}>Cancel</FancyButton>
                    <FancyButton variant="dark" onClick={onSave}>Save</FancyButton>
                </div>
            </DialogActions>
        </>
    );
}
